<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-card style="background: #e0e0e0;">
          <v-card-text>
            <LoaderApi apiUrl="portal/service-desk/order">
              <template slot-scope="orders">
                <v-app-bar flat dense color="#C5C5C5" class="my-5" v-if="orders && orders.data && orders.data.orders">
                  <v-toolbar-title v-if="orders.data.orders.length === 1">
                    <span>{{ orders.data.orders.length }} Ordem de Serviço</span>
                  </v-toolbar-title>
                  <v-toolbar-title v-else>
                    <span>{{ orders.data.orders.length }} Ordens de Serviço</span>
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                </v-app-bar>
                
                <!-- Lista de ordens agrupadas por mês -->
                <div v-if="orders && orders.data && orders.data.orders && orders.data.orders.length > 0">
                  <div class="timeline-container">
                    <div 
                      v-for="(monthGroup, monthKey) in groupOrdersByMonth(orders.data.orders)" 
                      :key="monthKey"
                      class="timeline-month-group"
                    >
                      <!-- Timeline Label -->
                      <div class="timeline-label">
                        <div class="timeline-label-content">
                          <div class="timeline-label-icon">
                            <v-icon color="white" size="18">event</v-icon>
                          </div>
                          <div class="timeline-label-text">
                            <h3 class="timeline-month-name">{{ monthGroup.monthName }}</h3>
                            <p class="timeline-year">{{ monthGroup.year }}</p>
                          </div>
                          <div class="timeline-label-count">
                            <v-chip 
                              color="white" 
                              small 
                              class="timeline-count-chip"
                            >
                              {{ monthGroup.orders.length }} {{ monthGroup.orders.length === 1 ? 'ordem' : 'ordens' }}
                            </v-chip>
                          </div>
                        </div>
                        <div class="timeline-line"></div>
                      </div>

                      <!-- Orders do mês -->
                      <div class="timeline-orders">
                        <v-row>
                          <OrderCard 
                            v-for="order in monthGroup.orders" 
                            :key="order.id"
                            :order="order"
                            @show-detail="showDetail"
                          />
                        </v-row>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Estado vazio quando não há ordens -->
                <div v-else-if="orders && orders.data && orders.data.orders && orders.data.orders.length === 0" class="empty-state">
                  <v-container class="text-center py-12">
                    <v-icon size="80" color="grey lighten-2" class="mb-4">assignment</v-icon>
                    <h2 class="text-h5 grey--text mb-3">Nenhuma ordem de serviço encontrada</h2>
                    <p class="text-body-1 grey--text mb-6">
                      Não há ordens de serviço disponíveis no momento.<br>
                      As ordens aparecerão aqui quando forem criadas.
                    </p>
                    <v-btn 
                      color="primary" 
                      outlined 
                      @click="refreshOrders"
                    >
                      <v-icon left>refresh</v-icon>
                      Atualizar
                    </v-btn>
                  </v-container>
                </div>

                <!-- Estado de carregamento -->
                <div v-else-if="!orders" class="loading-state">
                  <v-container class="text-center py-12">
                    <v-progress-circular
                      indeterminate
                      color="primary"
                      size="64"
                      class="mb-4"
                    ></v-progress-circular>
                    <h3 class="text-h6 grey--text">Carregando ordens de serviço...</h3>
                  </v-container>
                </div>
              </template>
            </LoaderApi>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import LoaderApi from "@/default/components/LoaderApi/LoaderApi";
import OrderCard from "./OrderCard.vue";

export default {
  name: "orders",

  data: () => ({
    sale: null,
    form: {},
  }),
  
  methods: {
    showDetail: function(order) {
      this.$router.push({ 
        name: 'order', 
        params: { id: order.uuid } 
      });
    },

    refreshOrders: function() {
      // Método para atualizar a lista de ordens
      // O LoaderApi irá recarregar automaticamente
      this.$forceUpdate();
    },

    // Método para converter data brasileira para Date
    parseBrazilianDate: function(dateStr) {
      try {
        if (!dateStr) return new Date();
        
        // Se já é uma data válida, retorna ela
        if (dateStr instanceof Date && !isNaN(dateStr)) {
          return dateStr;
        }
        
        // Se é string no formato brasileiro (DD/MM/YYYY)
        if (typeof dateStr === 'string' && dateStr.includes('/')) {
          const parts = dateStr.split('/');
          if (parts.length === 3) {
            const day = parseInt(parts[0], 10);
            const month = parseInt(parts[1], 10) - 1; // JavaScript months are 0-based
            const year = parseInt(parts[2], 10);
            
            // Validar se os valores são válidos
            if (isNaN(day) || isNaN(month) || isNaN(year)) {
              console.warn('Data inválida detectada:', dateStr);
              return new Date();
            }
            
            // Validar ranges
            if (day < 1 || day > 31 || month < 0 || month > 11 || year < 1900 || year > 2100) {
              console.warn('Data fora do range válido:', dateStr);
              return new Date();
            }
            
            const date = new Date(year, month, day);
            
            // Verificar se a data criada é válida (ex: 31/02/2024 seria inválida)
            if (date.getDate() !== day || date.getMonth() !== month || date.getFullYear() !== year) {
              console.warn('Data inválida (ex: 31/02):', dateStr);
              return new Date();
            }
            
            return date;
          }
        }
        
        // Se é string no formato ISO ou outro formato
        const parsedDate = new Date(dateStr);
        if (!isNaN(parsedDate) && parsedDate.getTime() > 0) {
          return parsedDate;
        }
        
        // Fallback para data atual
        console.warn('Não foi possível fazer parse da data:', dateStr);
        return new Date();
      } catch (error) {
        console.error('Erro ao fazer parse da data:', dateStr, error);
        return new Date();
      }
    },

    // Método para agrupar ordens com lógica inteligente
    groupOrdersByMonth: function(orders) {
      try {
        if (!orders || !Array.isArray(orders)) {
          console.warn('Orders não é um array válido:', orders);
          return {};
        }

        if (orders.length === 0) {
          return {};
        }

        // Primeiro, agrupar por mês
        const monthGroups = {};
        
        orders.forEach((order, index) => {
          try {
            // Validar se a ordem tem a estrutura esperada
            if (!order || typeof order !== 'object') {
              console.warn(`Ordem ${index} inválida:`, order);
              return;
            }

            const dateStr = order.date_start || order.created_at || new Date().toISOString();
            const date = this.parseBrazilianDate(dateStr);
            
            // Verificar se a data é válida
            if (isNaN(date.getTime())) {
              console.warn(`Data inválida para ordem ${order.id || index}:`, dateStr);
              return;
            }
            
            const monthKey = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
            
            if (!monthGroups[monthKey]) {
              monthGroups[monthKey] = {
                monthKey: monthKey,
                monthName: this.getMonthName(date.getMonth()),
                year: date.getFullYear(),
                month: date.getMonth(),
                orders: []
              };
            }
            
            monthGroups[monthKey].orders.push(order);
          } catch (error) {
            console.error(`Erro ao processar ordem ${index}:`, error, order);
          }
        });

        // Ordenar as ordens dentro de cada mês
        Object.keys(monthGroups).forEach(key => {
          try {
            monthGroups[key].orders.sort((a, b) => {
              const dateA = this.parseBrazilianDate(a.date_start || a.created_at);
              const dateB = this.parseBrazilianDate(b.date_start || b.created_at);
              return dateB - dateA;
            });
          } catch (error) {
            console.error(`Erro ao ordenar ordens do grupo ${key}:`, error);
          }
        });

        // Aplicar lógica de agrupamento inteligente
        const groupedResult = this.applySmartGrouping(monthGroups);
        
        // Ordenar os grupos por data (mais recente primeiro)
        const sortedGroups = {};
        try {
          const sortedKeys = Object.keys(groupedResult).sort((a, b) => {
            try {
              // Para grupos de mês: "2024-08"
              if (a.includes('-') && !a.includes('S')) {
                return b.localeCompare(a);
              }
              // Para grupos de semestre: "2024-S1"
              if (a.includes('-S')) {
                return b.localeCompare(a);
              }
              // Para grupos de ano: "2024"
              return parseInt(b) - parseInt(a);
            } catch (error) {
              console.error('Erro ao comparar chaves:', a, b, error);
              return 0;
            }
          });
          
          sortedKeys.forEach(key => {
            sortedGroups[key] = groupedResult[key];
          });
        } catch (error) {
          console.error('Erro ao ordenar grupos:', error);
          return groupedResult;
        }
        
        return sortedGroups;
      } catch (error) {
        console.error('Erro geral no agrupamento:', error);
        return {};
      }
    },

    // Método para aplicar agrupamento inteligente
    applySmartGrouping: function(monthGroups) {
      try {
        if (!monthGroups || typeof monthGroups !== 'object') {
          console.warn('monthGroups inválido:', monthGroups);
          return {};
        }

        const monthKeys = Object.keys(monthGroups).sort();
        
        if (monthKeys.length === 0) {
          return {};
        }

        // Verificar se todos os meses têm apenas 1 ordem
        const allMonthsHaveOneOrder = monthKeys.every(key => {
          const group = monthGroups[key];
          return group && Array.isArray(group.orders) && group.orders.length === 1;
        });
        
        if (allMonthsHaveOneOrder && monthKeys.length > 1) {
          // Agrupar por semestre
          const semesterGroups = {};
          
          monthKeys.forEach(key => {
            try {
              const group = monthGroups[key];
              if (!group || typeof group.month !== 'number' || typeof group.year !== 'number') {
                console.warn(`Grupo inválido para chave ${key}:`, group);
                return;
              }
              
              const semester = Math.floor(group.month / 6) + 1; // 1 ou 2
              const semesterKey = `${group.year}-S${semester}`;
              
              if (!semesterGroups[semesterKey]) {
                semesterGroups[semesterKey] = {
                  monthKey: semesterKey,
                  monthName: this.getSemesterName(semester),
                  year: group.year,
                  semester: semester,
                  orders: []
                };
              }
              
              if (Array.isArray(group.orders)) {
                semesterGroups[semesterKey].orders.push(...group.orders);
              }
            } catch (error) {
              console.error(`Erro ao processar grupo ${key}:`, error);
            }
          });

          // Verificar se todos os semestres têm apenas 1 ordem
          const semesterKeys = Object.keys(semesterGroups);
          const allSemestersHaveOneOrder = semesterKeys.every(key => {
            const group = semesterGroups[key];
            return group && Array.isArray(group.orders) && group.orders.length === 1;
          });
          
          if (allSemestersHaveOneOrder && semesterKeys.length > 1) {
            // Agrupar por ano
            const yearGroups = {};
            
            semesterKeys.forEach(key => {
              try {
                const group = semesterGroups[key];
                if (!group || typeof group.year !== 'number') {
                  console.warn(`Grupo de semestre inválido para chave ${key}:`, group);
                  return;
                }
                
                const yearKey = `${group.year}`;
                
                if (!yearGroups[yearKey]) {
                  yearGroups[yearKey] = {
                    monthKey: yearKey,
                    monthName: 'Ano',
                    year: group.year,
                    orders: []
                  };
                }
                
                if (Array.isArray(group.orders)) {
                  yearGroups[yearKey].orders.push(...group.orders);
                }
              } catch (error) {
                console.error(`Erro ao processar semestre ${key}:`, error);
              }
            });

            // Ordenar ordens dentro do ano
            Object.keys(yearGroups).forEach(key => {
              try {
                yearGroups[key].orders.sort((a, b) => {
                  const dateA = this.parseBrazilianDate(a.date_start || a.created_at);
                  const dateB = this.parseBrazilianDate(b.date_start || b.created_at);
                  return dateB - dateA;
                });
              } catch (error) {
                console.error(`Erro ao ordenar ordens do ano ${key}:`, error);
              }
            });

            return yearGroups;
          } else {
            // Usar agrupamento por semestre
            Object.keys(semesterGroups).forEach(key => {
              try {
                semesterGroups[key].orders.sort((a, b) => {
                  const dateA = this.parseBrazilianDate(a.date_start || a.created_at);
                  const dateB = this.parseBrazilianDate(b.date_start || b.created_at);
                  return dateB - dateA;
                });
              } catch (error) {
                console.error(`Erro ao ordenar ordens do semestre ${key}:`, error);
              }
            });
            return semesterGroups;
          }
        } else {
          // Usar agrupamento por mês (padrão)
          return monthGroups;
        }
      } catch (error) {
        console.error('Erro no agrupamento inteligente:', error);
        return monthGroups || {};
      }
    },

    // Método para obter nome do mês em português
    getMonthName: function(monthIndex) {
      try {
        const months = [
          'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
          'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
        ];
        
        if (typeof monthIndex !== 'number' || monthIndex < 0 || monthIndex > 11) {
          console.warn('Índice de mês inválido:', monthIndex);
          return 'Mês Inválido';
        }
        
        return months[monthIndex] || 'Mês Desconhecido';
      } catch (error) {
        console.error('Erro ao obter nome do mês:', error);
        return 'Erro';
      }
    },

    // Método para obter nome do semestre
    getSemesterName: function(semester) {
      try {
        if (typeof semester !== 'number' || (semester !== 1 && semester !== 2)) {
          console.warn('Semestre inválido:', semester);
          return 'Semestre Inválido';
        }
        
        return semester === 1 ? '1º Semestre' : '2º Semestre';
      } catch (error) {
        console.error('Erro ao obter nome do semestre:', error);
        return 'Erro';
      }
    }
  },

  computed: {
    config() {
      return this.$store.state.system.login;
    }
  },
  
  components: {
    LoaderApi,
    OrderCard
  },
};
</script>
<style scoped>
/* Estado vazio */
.empty-state {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  border-radius: 16px;
  margin: 20px 0;
}

.empty-state .v-icon {
  opacity: 0.7;
}

/* Estado de carregamento */
.loading-state {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 16px;
  margin: 20px 0;
}

/* Estilo global para SweetAlert */
.swal2-popup {
  font-family: "Open Sans", sans-serif;
}

.well-dates-row {
  display: flex !important;
  align-items: center !important;
}

/* Timeline Styles */
.timeline-container {
  position: relative;
  padding-left: 0;
}

.timeline-month-group {
  position: relative;
  margin-bottom: 40px;
  padding-left: 0;
}

.timeline-month-group:last-child {
  margin-bottom: 0;
}

/* Timeline Label */
.timeline-label {
  position: relative;
  margin-bottom: 24px;
  padding-left: 0;
}

.timeline-label-content {
  display: flex;
  align-items: center;
  background: linear-gradient(135deg, #1565c0 0%, #0d47a1 100%);
  border-radius: 12px;
  padding: 12px 16px;
  box-shadow: 0 3px 15px rgba(13, 71, 161, 0.4);
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
}

.timeline-label-content::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, transparent 30%, rgba(255, 255, 255, 0.1) 50%, transparent 70%);
  transform: translateX(-100%);
  transition: transform 0.6s ease;
}

.timeline-label:hover .timeline-label-content::before {
  transform: translateX(100%);
}

.timeline-label:hover .timeline-label-content {
  transform: translateY(-2px);
  box-shadow: 0 6px 25px rgba(13, 71, 161, 0.5);
}

.timeline-label-icon {
  background: rgba(255, 255, 255, 0.25);
  border-radius: 10px;
  padding: 6px;
  margin-right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.timeline-label:hover .timeline-label-icon {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.05);
}

.timeline-label-text {
  flex-grow: 1;
  color: white;
}

.timeline-month-name {
  font-size: 1.2rem;
  font-weight: 700;
  margin: 0 0 2px 0;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
  color: #ffffff;
}

.timeline-label:hover .timeline-month-name {
  transform: translateX(2px);
}

.timeline-year {
  font-size: 0.85rem;
  margin: 0;
  opacity: 0.95;
  font-weight: 600;
  transition: all 0.3s ease;
  color: #e3f2fd;
}

.timeline-label:hover .timeline-year {
  opacity: 1;
  transform: translateX(2px);
}

.timeline-label-count {
  margin-left: 12px;
}

.timeline-count-chip {
  background: rgba(255, 255, 255, 0.2) !important;
  border: 1px solid rgba(255, 255, 255, 0.4) !important;
  color: #ffffff !important;
  font-weight: 700 !important;
  transition: all 0.3s ease !important;
  font-size: 0.75rem !important;
}

.timeline-label:hover .timeline-count-chip {
  background: rgba(255, 255, 255, 0.25) !important;
  border-color: rgba(255, 255, 255, 0.5) !important;
  transform: scale(1.05);
}

/* Timeline Line */
.timeline-line {
  position: absolute;
  left: 0;
  top: 50%;
  width: 3px;
  height: 50px;
  background: linear-gradient(180deg, #1565c0 0%, #e3f2fd 100%);
  border-radius: 2px;
  transform: translateY(-50%);
  box-shadow: 0 2px 6px rgba(13, 71, 161, 0.4);
  transition: all 0.3s ease;
}

.timeline-month-group:last-child .timeline-line {
  height: 25px;
}

.timeline-label:hover + .timeline-line {
  background: linear-gradient(180deg, #0d47a1 0%, #bbdefb 100%);
  box-shadow: 0 3px 10px rgba(13, 71, 161, 0.5);
}

/* Timeline Orders */
.timeline-orders {
  padding-left: 0;
  position: relative;
}

.timeline-orders::before {
  content: '';
  position: absolute;
  left: 0;
  top: -20px;
  width: 2px;
  height: 20px;
  background: linear-gradient(180deg, #e3f2fd 0%, transparent 100%);
  border-radius: 1px;
}

/* Animações de entrada */
.timeline-month-group {
  animation: slideInFromLeft 0.6s ease-out;
}

.timeline-month-group:nth-child(1) { animation-delay: 0.1s; }
.timeline-month-group:nth-child(2) { animation-delay: 0.2s; }
.timeline-month-group:nth-child(3) { animation-delay: 0.3s; }
.timeline-month-group:nth-child(4) { animation-delay: 0.4s; }
.timeline-month-group:nth-child(5) { animation-delay: 0.5s; }

@keyframes slideInFromLeft {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* Responsividade */
@media (max-width: 768px) {
  .timeline-label-content {
    flex-direction: column;
    align-items: flex-start;
    padding: 10px 14px;
  }
  
  .timeline-label-icon {
    margin-right: 0;
    margin-bottom: 8px;
  }
  
  .timeline-label-count {
    margin-left: 0;
    margin-top: 6px;
    align-self: flex-end;
  }
  
  .timeline-month-name {
    font-size: 1.1rem;
  }
  
  .timeline-year {
    font-size: 0.8rem;
  }
  
  .timeline-line {
    display: none;
  }
}

@media (max-width: 600px) {
  .timeline-month-group {
    margin-bottom: 20px;
  }
  
  .timeline-label {
    margin-bottom: 14px;
  }
  
  .timeline-label-content {
    padding: 8px 12px;
  }
  
  .timeline-month-name {
    font-size: 1.0rem;
  }
  
  .timeline-year {
    font-size: 0.75rem;
  }
  
  .timeline-count-chip {
    font-size: 0.7rem !important;
  }
}
</style>
